import * as Notifications from 'expo-notifications';
import { Platform } from 'react-native';

// ─────────────────────────────────────────────────────────────────────────────

export function checkIfOrderFeedbackNotificationsEnabled() {
  return Platform.OS === 'ios' || Platform.OS === 'android';
}

export function getOrderFeedbackNotificationId(orderId: string) {
  return `${ORDER_FEEDBACK_NOTIFICATION_PREFIX}-${orderId}`;
}

export async function cancelAllOrderFeedbackNotifications() {
  if (!checkIfOrderFeedbackNotificationsEnabled()) return;

  const allScheduledNotifications = await Notifications.getAllScheduledNotificationsAsync();
  const allScheduledNotificationsIds = allScheduledNotifications
    .filter(checkIfOrderFeedbackNotification)
    .map((scheduledNotification) => scheduledNotification.identifier);

  if (allScheduledNotificationsIds.length === 0) return;

  await Promise.all(
    allScheduledNotificationsIds.map((notificationId) =>
      Notifications.cancelScheduledNotificationAsync(notificationId),
    ),
  );
}

export function checkIfOrderFeedbackNotification(scheduledNotification: {
  identifier: string | null | undefined;
}) {
  return scheduledNotification?.identifier?.startsWith?.(ORDER_FEEDBACK_NOTIFICATION_PREFIX);
}

// ─── Constants ───────────────────────────────────────────────────────────────

const ORDER_FEEDBACK_NOTIFICATION_PREFIX = 'order-feedback';
